import Vue from 'vue'
import VueRouter from 'vue-router'
import LoggedIn from '@/views/LoggedIn'


Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        name: "eap",
        component: LoggedIn
    },
    {
        path: "/general-info",
        name: "info",
        component: LoggedIn
    },
    {
        path: "/wellbeing",
        name: "wellbeing",
        component: LoggedIn
    },
    {
        path: "/wellbeing/articles",
        name: "allArticles",
        component: LoggedIn
    },
    {
        path: "/wellbeing/courses",
        name: "allCourses",
        component: LoggedIn
    },
    {
        path: "/wellbeing/:id",
        name: "course",
        component: LoggedIn
    },
    {
        path: "/wellbeing/article/:id",
        name: "article",
        component: LoggedIn
    },
    {
        path: "*",
        name: "not-found",
        component: LoggedIn
    },
    {
        path: "/be-calm",
        name: "beCalm",
        component: LoggedIn
    },
    {
        path: "/be-calm/:id",
        name: "beCalmCourse",
        component: LoggedIn
    },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
